<template>
    <select :value="value" @input="$emit('input', $event.target.value)">
        <option :key="index" v-for="(group, index) in groups" :value="index">
            {{ group }}
        </option>
    </select>
</template>

<script>
import pick from 'lodash/pick';
import groups from '@/data/groups';

export default {
    name: 'group-select',
    props: {
        value: {
            type: String,
        },
        accessibleGroups: {
            type: Array,
        },
    },
    computed: {
        groups() {
            if (this.accessibleGroups && this.accessibleGroups.length) {
                return pick(groups, this.accessibleGroups);
            }
            return groups;
        },
    },
};
</script>
